import React, {useEffect, useRef, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import {getFireStatusAlarms, modFireStatus} from "../../api/apiClient";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ComboFireStatus from "../../components/inputs/ComboFireStatus";
import FireAlarmRelease from "./FireAlarmRelease";
import Swal from "sweetalert2";

const FireStatusManage = ({
                            propData = {},
                            setClose = null
                          }) => {

  const [stIsReadOnly, setIsReadOnly] = useState(false);

  useEffect(() => {
    if (propData.fire_sttus_nm === '화재종료') {
      setIsReadOnly(true);
    }
    getAlarms();
  }, []);

  const onChangeFireStatus = (e) => {
    fireStatus.current = e.target.value;
  };

  /*const onChangeFireCause = (e) => {
    fireCause.current = e.target.value;
  };*/

  const fireStatus = useRef(0);
  // const fireCause = useRef(1);

  const saveCurrent = () => {
    modFireStatus(
        propData.fire_no,
        fireStatus.current,
        // fireCause.current
    )
        .then(res => {
          if (res.data.status === 200) {
            Swal.fire(
                '정상적으로 처리 되었습니다!',
                '',
                'success'
            );
            setClose();
          } else {
            Swal.fire(
                '처리 중 오류가 발생하였습니다!',
                '',
                'error'
            );
            setClose();
          }
        })
        .catch(err => {
          Swal.fire(
              '처리 중 오류가 발생하였습니다!',
              '',
              'error'
          );
          setClose();
        });
    // setClose();
  };

  const [fireAlarmReleaseData, setFireAlarmReleaseData] = useState([]);

  const getAlarms = () => {
    getFireStatusAlarms(propData.fire_no)
        .then((res) => {
              setFireAlarmReleaseData(res.data.data.list);
            }
        )
  };


  return (
      <Container fluid className={"layer p-2"}>
        <Row className={""}>
          <Col className={''}>
            <Row className={"info-container py-2 mx-3"}>
              <Col md={12} className={'px-5'}>
                <div className={'content-container-body-item'}>
                  <FireAlarmRelease
                      propData={fireAlarmReleaseData}
                      updateList={getAlarms}
                  />
                </div>
              </Col>
            </Row>

            <Row className={'info-container py-2 mx-3'}>
              <Col md={11} className={'px-5'}>
                <div className={'content-container-body-item'}>
                  <Form
                      className={'gateway-register-form py-3'}
                      id={'gatewayRegisterForm'}
                  >
                    <Row className={"justify-content-center"}>
                      <Col md={12}>
                        <Row>
                          <Col md={12}>
                            <Form.Group as={Row} controlId="formGtwyId">
                              <Form.Label column md={3} className={'label text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>시설명
                              </Form.Label>
                              <Col md={9} className={''}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    readOnly={true}
                                    defaultValue={propData.fclty_nm}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <ComboFireStatus
                                propDefault={propData.fire_sttus_nm}
                                propOnChange={onChangeFireStatus}
                                propLocation={"FIELD"}
                            />
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formIp2Addr'>
                              <Form.Label column md={3} className={'label text-end'}>
                                발생시간
                              </Form.Label>
                              <Col md={9}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    readOnly={true}
                                    defaultValue={propData.ocrn_dt_str}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='forml2IpAddr'>
                              <Form.Label column md={3} className={'label text-end'}>
                                종료시간
                              </Form.Label>
                              <Col md={9}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    readOnly={true}
                                    defaultValue={propData.updt_dt_str}
                                />
                              </Col>
                            </Form.Group>
                          </Col>


                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            </Row>

            <Row className={"my-3 justify-content-center"}>
              <Col md={2} className={'text-center'}>
                <Button onClick={saveCurrent} className={'btn save-btn w-100'} disabled={stIsReadOnly}>저장</Button>
              </Col>
              <Col md={2} className={'text-center'}>
                <Button onClick={setClose} className={'btn btn-secondary w-100'}>취소</Button>
              </Col>
            </Row>
          </Col>

        </Row>
      </Container>
  );
};

export default FireStatusManage;
